import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyMsaById($id: MongoID!) {
    cat {
      distributionSubcategory{
        byId(_id: $id) {
          _id
          staffingAgency {
            msa {
              dateSigned
              conversionTimeframe
              conversionFees
              dhAvailable
              dhWarranty
              nonSolicitationDuration
            } 
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyMsaById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useStaffingAgencyMsaById = (id: string): StaffingAgencyMsaById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distribution = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distribution
}

export { useStaffingAgencyMsaById, document as staffingAgencyMsaByIdDocument }
